import React, { FunctionComponent, useMemo } from "react"
import { Box, Paper, makeStyles, Theme, useTheme } from "@material-ui/core"
import { Legend, LegendKey } from "../common/Legend"

/** MapLegend component props */
interface MapLegendProps {}

/** Scoped @material-ui/core stylesheet */
const useStyles = makeStyles<Theme>(theme => ({
  paper: {
    position: "absolute",
    right: theme.spacing(8),
    bottom: theme.spacing(4),
  },
}))

export const MapLegend: FunctionComponent<MapLegendProps> = () => {
  /** Get scoped CSS classes */
  const classes = useStyles()

  const theme = useTheme()
  const keys: LegendKey[] = useMemo(
    () => [
      {
        label: "Insufficient content",
        color: theme.palette.primary.main,
      },
      {
        label: "Needs work",
        color: theme.palette.warning.main,
      },
      {
        label: "Complete",
        color: theme.palette.success.main,
      },
    ],
    [theme]
  )

  return (
    <Paper className={classes.paper} elevation={0}>
      <Box pl={2} pt={0.5} pb={0.5}>
        <Legend keys={keys} />
      </Box>
    </Paper>
  )
}
